import React from "react";
import { DatePicker } from "@mui/x-date-pickers";
import { useSearchParams } from "react-router-dom";
import { TimeService, getMomentTz } from "@dexteel/mesf-core";
import { useWorkOrdersContext } from "../context/workOrdersContext";
import { cmmsTheme } from "@setup/theme/cmms-theme";

const moment = getMomentTz();

type Props = {};

export const StartFilter = ({}: Props) => {
	const [searchParams, setSearchParams] = useSearchParams();

	const {
		state: {
			dataToGetWorkOrders: { Start, End },
		},
	} = useWorkOrdersContext();

	const handleDateChange = (date: any) => {
		if (date && moment(date).isValid()) {
			const selectedDate = moment(date).startOf("day");
			const endDate = moment(End);

			if (endDate.isValid() && selectedDate.isAfter(endDate, "day")) {
				const startIsoString = selectedDate.toDate().toISOString();
				const endIsoString = selectedDate
					.clone()
					.endOf("day")
					.toDate()
					.toISOString();
				searchParams.set("start", encodeURIComponent(startIsoString));
				searchParams.set("end", encodeURIComponent(endIsoString));
				setSearchParams(searchParams, { replace: true });
			} else {
				const isoString = selectedDate.toDate().toISOString();
				searchParams.set("start", encodeURIComponent(isoString));
				setSearchParams(searchParams, { replace: true });
			}
		}
	};

	return (
		<DatePicker
			label="Start"
			timezone={TimeService.getInstance().getServerTimeZone()}
			format="MM/DD/YYYY"
			value={moment(Start) as any}
			onChange={handleDateChange}
			slotProps={{
				textField: {
					fullWidth: true,
					variant: "outlined",
					margin: "dense",
					InputProps: {
						style: {
							height: cmmsTheme.dimensions.standardInput,
							marginTop: cmmsTheme.spacing.inputOffset,
						},
					},
					InputLabelProps: {
						style: {
							fontSize: "14px",
						},
					},
				},
			}}
		/>
	);
};
